module.exports = __webpack_public_path__ + "img/Answer.5f40f5b3.svg";